export enum NavigationTypeEnum {
  backOffice = 1,
  shop = 2,
  error = 3,
  newUser = 4
}
